/**
 * The one glue point between the audio engine and `settings.svelte.ts`.
 * Deliberately its own file rather than folded into `engine.ts`: everything
 * in `engine.ts`/`sequencer.ts`/`danger.ts`/`gain.ts` runs under plain
 * Vitest with no Svelte plugin, the same reason `settings-io.ts` is split
 * from `settings.svelte.ts` — importing a `.svelte.ts` module (which needs
 * the Svelte compiler for its runes) from there would break that.
 */
import { settings } from '../state/settings.svelte.js';
import { audio } from './engine.js';

/**
 * Call from inside the click handler for the Start/Join tap — the one
 * gesture `docs/DESIGN.md`'s owner brief allows `AudioContext` creation
 * from. Safe to call again from any later gesture too (idempotent).
 */
export function startAudioForGesture(): void {
  audio.start();
  audio.setMusicEnabled(settings.musicOn);
  audio.setMusicVolume(settings.musicVolume);
  audio.setSfxEnabled(settings.sfxOn);
  audio.setSfxVolume(settings.sfxVolume);
  void audio.resume();
}
